import React, { useState } from "react";
import { Tooltip } from "antd";
import { FaQuestionCircle } from 'react-icons/fa';
import { TooltipCard, TooltipText } from './styles';


const TooltipComponent = ({ guidance, size, isColumnOverlap }) => {
  const [open, setOpen] = useState(false);

  const guidanceText = guidance != null && guidance !== "" && guidance !== "n/a"
    ? guidance
    : "No guidance";

  const tooltipWidth = guidance?.length >= 500 ? 440 : guidance?.length > 30 ? 320 : 240;

  return (
    <TooltipCard>
      <Tooltip
        title={<span style={{ fontSize: 12, whiteSpace: "pre-wrap" }}>{guidanceText}</span>}
        open={open}
        onOpenChange={setOpen}
        trigger={["click", "hover"]}
        placement="rightTop"
        overlayStyle={{
          maxWidth: tooltipWidth,
          marginLeft: isColumnOverlap ? 210 : 0,
        }}
        overlayInnerStyle={{
          backgroundColor: "#f7f7f7",
          color: "#000",
          boxShadow: "0px 3px 6px #00000029",
          borderRadius: 4,
          padding: "8px",
          maxHeight: "60vh",
          overflowY: "auto",
        }}
        color="#f7f7f7"
      >
        <TooltipText className={open ? "active" : ""}>
          <FaQuestionCircle size={size} style={open ? { color: "#112A61" } : {}} />
        </TooltipText>
      </Tooltip>
    </TooltipCard>
  );
}

export default TooltipComponent;
